import styled from "styled-components";

export const Component = styled.div`
  position: relative;
  iframe,
  embed,
  object,
  video {
    margin: 0 auto;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    border: 0;
  }
`;
